import ISRCCallsTable from "../components/ISRCCallsTable";

const ISRCCallsPage = () => {
    return (
        <>
            <ISRCCallsTable />
        </>
    );
};

export default ISRCCallsPage;
